import React from 'react';
import {
  Home,
  DollarSign,
  UserPlus,
  Users,
  Cast,
  Settings,
  Airplay,
  FolderPlus,
  File,
  Command, Cloud, Book, FileText, Server, Image, Sliders, Map, GitPullRequest, Calendar, Edit, Mail, MessageSquare, UserCheck, Layers, HelpCircle, Database, Headphones, Mic, ShoppingBag, Search, AlertOctagon, Lock, Briefcase, BarChart, Target, List, Package,
} from 'react-feather';
import { t } from 'react-switch-lang';

export const MENUITEMS = [
  {
    title: t('modules.Dashboard'),
    icon: Home,
    type: 'link',
    path: '/app/dashboard',
    badgeType: 'primary',
    active: false,
    roles: ['developer'],
  },
  {
    title: t('modules.Users'),
    icon: Users,
    type: 'link',
    path: '/app/users',
    badgeType: 'primary',
    active: false,
    roles: ['developer', 'owner', 'head of marketing'],
  },
  {
    title: t('modules.Settings'),
    icon: Settings,
    type: 'link',
    path: '/app/settings',
    badgeType: 'primary',
    active: false,
    roles: ['developer', 'owner', 'head of marketing'],
  },
  {
    title: t('modules.Channels'),
    icon: Cast,
    type: 'link',
    path: '/app/channels',
    badgeType: 'primary',
    active: false,
    roles: ['developer', 'owner', 'head of marketing', 'manager'],
  },
];
